module.exports = __webpack_public_path__ + "static/media/Termites.855be8f2.svg";